module.exports = __webpack_public_path__ + "img/11.f3374bad.jpg";